export default "__VITE_ASSET__65bafa9b__"